import { createSandbox, HeadGoverness } from 'vue-kindergarten'

import { RoutePerimeter } from '../perimeters'

export class RouteGoverness extends HeadGoverness {
  guard(action, { next, to }) {
    // If we really want to go to signin, set the default redirect path to '/'
    let target =
      to.name === 'signin' ? { name: 'signin', query: to.query } : { name: 'signin', query: { redirect: to.fullPath } }
    return this.isAllowed(action) ? next() : next(target)
  }
}

export const child = (store) => {
  if (store) {
    return store
  }
}

export const navGuard = (router, store) => {
  router.beforeEach((to, from, next) => {
    store
      .dispatch('auth/configureClient')
      .then(() => {
        to.matched.some((routeRecord) => {
          const perimeter = routeRecord.meta.perimeter || RoutePerimeter
          const Governess = routeRecord.meta.governess || RouteGoverness
          const action = routeRecord.meta.perimeterAction || 'route'

          if (perimeter) {
            // router.app.store is empty on page reload
            // as a result, any validation fails, even if we have a token in storage.
            // getting the store from above solves this.
            const sandbox = createSandbox(child(store), {
              governess: new Governess(),
              perimeters: [perimeter]
            })
            return sandbox.guard(action, { to, from, next })
          }
          return next()
        })
      })
      .catch(() => {
        return next()
      })
  })
}
